module.exports = __webpack_public_path__ + "img/book-4.52cea1df.png";